const colorCodeMapping = {
  black: 'black',
  blackmesh: 'black',
  red: '#d20f0f',
  blue: '#2863bd',
  green: '#008000',
  gray: '#adadad',
  grey: '#adadad',
  biege: '#ece3b4',
  beige: '#ece3b4',
  coffee: '#6F4E37',
  maroon: '#800000',
  charcoal: '#36454F',
  brown: '#964B00',
  chocolate: '#7B3F00',
  orange: '#FFA500',
  yellow: '#FFFF00',
  lightblue: '#ADD8E6',
  darkblue: '#00008B',
  golden: '#bba211',
};

const dualColorDelimiters = [/\s*\/\s*/, /\s+&\s+/, /\s+and\s+/i];

export const getColorCode = (color) => {
  return colorCodeMapping[color.trim().toLowerCase()] || color.trim();
};

export const parseColorValue = (color) => {
  const label = (color || '').trim();

  for (const delimiter of dualColorDelimiters) {
    if (delimiter.test(label)) {
      const parts = label.split(delimiter).map((part) => part.trim()).filter(Boolean);
      if (parts.length === 2) {
        return { label, parts, isDual: true };
      }
    }
  }

  return { label, parts: [label], isDual: false };
};

export const getSwatchBackgroundStyle = (color) => {
  const { parts, isDual } = parseColorValue(color);

  if (!isDual) {
    return { backgroundColor: getColorCode(parts[0]) };
  }

  const [primaryColor, secondaryColor] = parts.map((part) => getColorCode(part));

  // Equal 50/50 curved split: overlay circle centered on the top-right edge
  return {
    backgroundImage: `radial-gradient(circle at 100% 0%, ${secondaryColor} 50%, ${primaryColor} 50%)`,
  };
};